// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"authProvider_mulitpleDropdown__2A8yJ","loaderWrapper":"authProvider_loaderWrapper__pnlv9"};